export default {
  input: {
    backgroundColor: '#fff',
    paddingLeft: '15px',
    height: 40,
    borderRadius: 8,
    borderColor: '#707070',
    fontSize: 16,
    marginTop: 10,
    display: 'inline',
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/login-form/LoginForm.styles.js